import { useDispatch, useSelector } from 'react-redux';
import { setSectionType } from '../../../../Features/storefrontSlice';
import SectionGray from '../../../../Assets/StorefrontIcons/SectionGray.svg';
import SectionGreen from '../../../../Assets/StorefrontIcons/SectionGreen.svg';
import MediaGray from '../../../../Assets/StorefrontIcons/MediaGray.svg';
import MediaGreen from '../../../../Assets/StorefrontIcons/MediaGreen.svg';
import SEOGray from '../../../../Assets/StorefrontIcons/SEOGray.svg';
import SEOGreen from '../../../../Assets/StorefrontIcons/SEOGreen.svg';
import { showToast } from '../../../../Components/Toaster/Toaster';

function SectiontypeButtons() {
    const dispatch = useDispatch();

    const sectionType = useSelector((state) => state.storefront.sectionType);
    const viewType = useSelector((state) => state.storefront.viewType);

    function updateSection(section) {
        if (viewType === 'MOBILE' && section === 'SECTION') {
            showToast('Please edit the storefront in web view.', 'warning');
            return;
        }
        dispatch(setSectionType(section));
    }

    return (
        <div className="flex flex-col gap-1 mt-4">
            <button onClick={() => updateSection('SECTION')} className={`mx-[5px] outline-none px-4 py-1 ${(sectionType === 'SECTION' && viewType === 'DESKTOP') && 'rounded-lg bg-[#A6FFCB]'} flex flex-col items-center`}>
                <div className="size-[30px] flex items-center justify-center">
                    <img src={(sectionType === 'SECTION' && viewType === 'DESKTOP') ? SectionGreen : SectionGray} alt="" />
                </div>

                <p className={`font-medium text-[10px] leading-5 ${(sectionType === 'SECTION' && viewType === 'DESKTOP') ? 'text-[#127C3E]' : 'text-[#6B7280]'}`}>Section</p>
            </button>

            <button onClick={() => updateSection('MEDIA')} className={`mx-[5px] outline-none px-4 py-1 ${sectionType === 'MEDIA' && 'rounded-lg bg-[#A6FFCB]'} flex flex-col items-center`}>
                <div className="size-[30px] flex items-center justify-center">
                    <img src={sectionType === 'MEDIA' ? MediaGreen : MediaGray} alt="" />
                </div>

                <p className={`font-medium text-[10px] leading-5 ${sectionType === 'MEDIA' ? 'text-[#127C3E]' : 'text-[#6B7280]'}`}>Media</p>
            </button>

            <button onClick={() => updateSection('SEO')} className={`mx-[5px] outline-none px-4 py-1 ${sectionType === 'SEO' && 'rounded-lg bg-[#A6FFCB]'} flex flex-col items-center`}>
                <div className="size-[30px] flex items-center justify-center">
                    <img src={sectionType === 'SEO' ? SEOGreen : SEOGray} alt="" />
                </div>

                <p className={`font-medium text-[10px] leading-5 ${sectionType === 'SEO' ? 'text-[#127C3E]' : 'text-[#6B7280]'}`}>SEO</p>
            </button>
        </div>
    );
}

export default SectiontypeButtons;
